import { render, staticRenderFns } from "./salarySummary.vue?vue&type=template&id=c0086e9e&scoped=true"
import script from "./salarySummary.vue?vue&type=script&lang=js"
export * from "./salarySummary.vue?vue&type=script&lang=js"
import style0 from "./salarySummary.vue?vue&type=style&index=0&id=c0086e9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0086e9e",
  null
  
)

export default component.exports